/**
 * Progress Stars
 * 
 */
'use strict';

export class ProgressStars
{
  constructor()
  {
    this.init();
  }

  init()
  {
    const progress_stars = document.querySelectorAll('.progress-stars');

    progress_stars?.forEach((progress_star, key) => {
      const value = progress_star.getAttribute('data-value');
      const stars = [1, 2, 3, 4, 5].map(( i ) => {
        // Default is filled star
        let offset = '100';

        if ( i - 1 >= value ) {
          offset = 0;
        }
        else if ( value < i ) {
          offset = Math.floor( Math.abs( i - value - 1 ) * 100 );
        }

        return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="grad${key}-${i}">
              <stop offset="${offset}%" stop-color="#009DD9"/>
              <stop offset="${offset}%" stop-color="white"/>
            </linearGradient>
          </defs>
          <path d="M9.99982 0.954895L12.9387 6.90981L19.5104 7.86473L14.7551 12.5L15.8777 19.0451L9.99982 15.9549L4.12197 19.0451L5.24454 12.5L0.489258 7.86473L7.0609 6.90981L9.99982 0.954895Z" fill="url(#grad${key}-${i})"/>
        </svg>`;
      }).join('');

      progress_star.innerHTML = stars;
    });
  }
}